import React, { useState, useEffect } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Home from "./components/home/home";
import Login from "./components/login/login";
import Splash from "./components/splash/splash";
import Otp from "./components/otp/otp";
import AppConstants from "./components/AppConstants";
import { GoogleMapsProvider } from "./utils/mapConfig";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Message from "./firebase/message";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase/firebaseConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PreventBack from "./components/preventBack";
import axios from "axios";

const REACT_APP_VAPID_KEY = process.env.REACT_APP_VAPID_KEY;

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [fcmToken, setFcmToken] = useState(null);

  // Register Service Worker
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }, []);

  const saveFcmTokenToBackend = async (token) => {
    try {
      const jwtToken = localStorage.getItem(AppConstants.JWT);
      
      if (!jwtToken) {
        console.log("No JWT token available, FCM token will be saved after login");
        return;
      }

      const response = await axios.post(
        "https://main.hifiservices.in/auth/fcm/save/",
        {
          device_type: "web",
          token: token,
        },
        {
          headers: {
            'Authorization': `Token ${jwtToken}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        }
      );

      console.log("FCM token saved to backend:", response.data);
    } catch (error) {
      console.error("Error saving FCM token to backend:", error);
    }
  };

  useEffect(() => {
    async function requestPermission() {
      const permission = await Notification.requestPermission();
      console.log("Notification permission:", permission);

      if (permission === "granted") {
        try {
          const token = await getToken(messaging, { vapidKey: REACT_APP_VAPID_KEY });
          console.log("Generated FCM Token:", token);
          setFcmToken(token);
          localStorage.setItem(AppConstants.FCM, token);
          
          saveFcmTokenToBackend(token);
        } catch (error) {
          console.error("Error getting FCM token:", error);
        }
      } else {
        console.warn("Notification permission denied");
        // Show a user-friendly message
        toast.warning("Please enable notifications to receive updates");
      }
    }

    requestPermission();
  }, []);

  // Handle in-app notifications (when app is open)
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      
      // Show toast notification
      toast(<Message notification={payload.notification} />);
      
      // Also show browser notification if permission granted
      if (Notification.permission === 'granted') {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.icon || '/logo192.png',
          badge: '/logo192.png',
          tag: payload.notification.tag || 'default',
          requireInteraction: false,
        });
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 5);
  }, []);

  const checkAndSaveFcmToken = () => {
    const storedFcmToken = localStorage.getItem(AppConstants.FCM);
    if (storedFcmToken) {
      saveFcmTokenToBackend(storedFcmToken);
    }
  };

  function ProtectedRoute({ children }) {
    const token = localStorage.getItem(AppConstants.JWT);
    
    if (token) {
      checkAndSaveFcmToken();
    }
    
    return token ? children : <Navigate to="/login" replace />;
  }

  return (
    <>
      <GoogleMapsProvider>
        <div className="App" style={{ visibility: isLoading ? "hidden" : "visible", opacity: isLoading ? 0 : 1 }}>
          <Router>
            <PreventBack />
            <Routes>
              <Route path="/" element={<Splash fcmToken={fcmToken} isLoading={isLoading} />} />
              <Route path="/login" element={<Login onLoginSuccess={checkAndSaveFcmToken} />} />
              <Route path="/otp" element={<Otp onAuthSuccess={checkAndSaveFcmToken} />} />
              <Route
                exact
                path="/home"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Router>
        </div>
      </GoogleMapsProvider>
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;